import { render, staticRenderFns } from "./grading-card.vue?vue&type=template&id=653351ad&scoped=true&lang=pug"
import script from "./grading-card.vue?vue&type=script&lang=ts"
export * from "./grading-card.vue?vue&type=script&lang=ts"
import style0 from "./grading-card.vue?vue&type=style&index=0&id=653351ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653351ad",
  null
  
)

export default component.exports